'use client';

import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import CustomerHomeContent from './components/CustomerHomeContent';

export default function CustomerHomePage() {
  const router = useRouter();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const role = localStorage.getItem('vq_role');
    if (!role) {
      router?.replace('/login');
    } else if (role === 'seller') {
      router?.replace('/seller-scan-screen');
    } else {
      setReady(true);
    }
  }, [router]);

  if (!ready) return null;
  return <CustomerHomeContent />;
}